let isWindowLoaded = false;
$(window).one('load', () => {
	isWindowLoaded = true;
});

let log = () => {};

// uncomment to enable logging
// log = console.log;

/**
 * This plugin calculates font size for element to fit parent.
 * It incrementally changes font size until element's dimensions are most close to parent's.
 * To manually fix font size trigger 'refresh-font-size' event
 * @param options
 * @return {JQuery}
 */
$.fn.adaptiveFontSize = function (options = null) {
	const o = {
		minFontSize: '30%',
		maxFontSize: '100%',
		// 'up' or 'down'. Either increase font size starting from min, or decrease starting from max
		direction: 'down',
		// If null - immediate parent will be used, otherwise: $(element).parents(o.parentSelector)
		parentSelector: null,
		// Set font size only if window is already loaded.
		// Don't forget to enable fixOnLoad option
		setIfLoaded: true,
		// Fix font size on window resize event
		fixOnResize: true,
		// Fix font size on window load event
		fixOnLoad: true,

		// Done callback. Called when font size is finally set. Accepts two parameters - DOM Element and font size
		done: null,

		...options
	};
	return this.each(function () {
		const $block = $(this);
		init();

		function init() {
			if (!o.setIfLoaded || isWindowLoaded) {
				process();
			}
			else {
				log('postpone set');
			}
			if (o.fixOnResize) {
				$(window).on('resize', eventHandler);
			}
			if (o.fixOnLoad) {
				$(window).on('load', eventHandler);
			}
			$block.on('refresh-font-size', eventHandler);
		}

		function eventHandler() {
			log('fix on event');
			process();
		}

		function getParent() {
			return o.parentSelector ? $block.parents(o.parentSelector).first() : $block.parent();
		}

		function process() {
			if (!$.contains(document, $block[0])) {
				// element has been detached, stop processing
				log('stop processing');
				$(window).off('resize', eventHandler);
				$(window).off('load', eventHandler);
				$block.off('refresh-font-size', eventHandler);
				return;
			}

			const $parent = getParent();
			const isPercent = ('' + o.minFontSize).indexOf('%') >= 0;
            const minFontSize = parseFloat(o.minFontSize);
            const maxFontSize = parseFloat(o.maxFontSize);
            let delta = Math.floor((maxFontSize - minFontSize) / 10);
			let initial = minFontSize;
			if (o.direction == 'down') {
				delta *= -1;
				initial = maxFontSize;
			}
			const fontSize = calculateFontSize($block, $parent.width(), $parent.height(), initial, minFontSize, maxFontSize, delta, isPercent);
			if ($.isFunction(o.done)) {
				log('done', fontSize);
				o.done($block[0], fontSize);
			}
		}
	});
};

function addDelta(value, delta, min, max) {
	let newValue = value + delta;
	if (newValue > max) newValue = max;
	if (newValue < min) newValue = min;
	return newValue;
}

function calculateFontSize($block, maxWidth, maxHeight, fontSize, minFontSize, maxFontSize, delta, isPercent) {
	let newFontSize = addDelta(fontSize, delta, minFontSize, maxFontSize);
	if (newFontSize == fontSize) {
		return fontSize;
	}
	setFontSize($block, newFontSize, isPercent);
	if (delta > 0) {
		if ($block.width() < maxWidth && $block.height() < maxHeight) {
			return calculateFontSize($block, maxWidth, maxHeight, newFontSize, minFontSize, maxFontSize, delta, isPercent);
		}
		else {
			// rollback
            setFontSize($block, fontSize, isPercent);
			return fontSize;
		}
	}
	else {
		if ($block.width() > maxWidth || $block.height() > maxHeight) {
			return calculateFontSize($block, maxWidth, maxHeight, newFontSize, minFontSize, maxFontSize, delta, isPercent);
		}
	}
	return newFontSize;
}

function setFontSize($block, fontSize, isPercent) {
	if (isPercent) {
		fontSize += '%';
	}
    $block.css('font-size', fontSize);
}



// WEBPACK FOOTER //
// ./lib/adaptivefontsize/index.js